import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import * as appointmentActions from 'yoda-site-components/lib/actions/AppointmentActions';
import * as sliderActions from 'yoda-site-components/lib/actions/AccountAction';
import analyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import RedirectAction from 'yoda-app-shell/lib/action/RedirectAction';

import CAMDashboardPage from './CAMDashboard';
import * as actions from '../../../actions/CAMDashboardActions';
import * as accountDetailsActions from '../../../actions/AccountDetailsActions';

function mapStateToProps(state) {
    return {
        deviceType: state.context.deviceType,
        featureFlags: state.context.featureFlags,
        messagesTexts: state.context.messagesTexts,
        preferences: state.context.preferences,
        appointmentDetails: state.appointmentDetails,
        headers: state.context.headers,
        mountOnServer: true,
        onVerifyOtpSuccess: get(state.phoneVerification, 'verifyOTPDetails.success', false),
        accountDetails: state.accountDetails,
        userProfile: get(state.accounts, 'userProfile', {}),
        syfQuickScreen: state.syfQuickScreen,
    };
}
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    accountDetailsActions: bindActionCreators(accountDetailsActions, dispatch),
    appointmentActions: bindActionCreators(appointmentActions, dispatch),
    sliderActions: bindActionCreators(sliderActions, dispatch),
    redirectAction: bindActionCreators(RedirectAction, dispatch),
    analyticsAction: bindActionCreators(analyticsAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CAMDashboardPage);
